/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceTypeCertificateRequest
 */
export interface DeviceTypeCertificateRequest {
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeCertificateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeCertificateRequest
     */
    data: string;
}

export function DeviceTypeCertificateRequestFromJSON(json: any): DeviceTypeCertificateRequest {
    return DeviceTypeCertificateRequestFromJSONTyped(json, false);
}

export function DeviceTypeCertificateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceTypeCertificateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'data': json['data'],
    };
}

export function DeviceTypeCertificateRequestToJSON(value?: DeviceTypeCertificateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'data': value.data,
    };
}

